import type {DateRangeWithTimezone} from '@spaced-out/ui-design-system/lib/types';
import type {AnalyticsNPSDashboardActions} from 'src/action-creators/analytics/analytics-nps-dashboard';
import type {SelectedSurveyNpsFilterColumnsData} from 'src/types/analytics-genesis';
import {
  SET_SELECTED_DATE_RANGE,
  SET_CURRENT_DASHBOARD_ID,
  RECEIVE_CANDIDATE_NPS_TABLE_COLUMNS,
  RECEIVE_CLIENT_NPS_TABLE_COLUMNS,
  RECEIVE_CANDIDATE_NPS_CHART_COLUMNS,
  RECEIVE_CLIENT_NPS_CHART_COLUMNS,
} from 'src/action-creators/analytics/analytics-nps-dashboard';


export type AnalyticsNPSDashboardState = {
  selectedDateRange: DateRangeWithTimezone;
  currentDashboardID: string | null | undefined;
  candidateNPSTableColumnFilter: SelectedSurveyNpsFilterColumnsData | null;
  clientNPSTableColumnFilter: SelectedSurveyNpsFilterColumnsData | null;
  candidateNPSChartColumnFilter: Array<string> | null;
  clientNPSChartColumnFilter: Array<string> | null;
};

const initialState: AnalyticsNPSDashboardState = {
  selectedDateRange: {
    startDateUTC: null,
    startDate: null,
    endDateUTC: null,
    endDate: null,
  },
  currentDashboardID: null,
  candidateNPSTableColumnFilter: null,
  clientNPSTableColumnFilter: null,
  candidateNPSChartColumnFilter: null,
  clientNPSChartColumnFilter: null,
};

export default (
  state: AnalyticsNPSDashboardState = initialState,
  action: AnalyticsNPSDashboardActions,
): AnalyticsNPSDashboardState => {
  switch (action.type) {
    case SET_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case SET_SELECTED_DATE_RANGE: {
      return {
        ...state,
        selectedDateRange: action.payload,
      };
    }
    case RECEIVE_CANDIDATE_NPS_TABLE_COLUMNS: {
      return {
        ...state,
        candidateNPSTableColumnFilter: action.payload,
      };
    }
    case RECEIVE_CLIENT_NPS_TABLE_COLUMNS: {
      return {
        ...state,
        clientNPSTableColumnFilter: action.payload,
      };
    }
    case RECEIVE_CANDIDATE_NPS_CHART_COLUMNS: {
      return {
        ...state,
        candidateNPSChartColumnFilter: action.payload,
      };
    }
    case RECEIVE_CLIENT_NPS_CHART_COLUMNS: {
      return {
        ...state,
        clientNPSChartColumnFilter: action.payload,
      };
    }
  }
  return state;
};
